import axios, { AxiosInstance } from 'axios'

var baseURL = 'https://api.solscratch.fun/api/';
var basePriceURL = 'https://min-api.cryptocompare.com/data/';

const apiData: AxiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 30000, // 30 secs
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const api: AxiosInstance = axios.create({
  baseURL: basePriceURL,
  timeout: 30000, // 30 secs
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})


export async function apiSolPrice() {
	const response = await api.get(
		`price?fsym=SOL&tsyms=USD`
	)
	
	return response
}

export async function apiGetCard(card_id) {
	const response = await apiData.get(
		`getcard?card_id=${card_id}`
	)
	
	return response
}